import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import GoogleLoginButton from "../components/GoogleLoginButton";


export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/");
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === "string" ? d : "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="login-page" className="max-w-md mx-auto px-4 md:px-8 py-24">
      <span className="tag tag-accent">// ACCESS</span>
      <h1 className="font-display font-black text-4xl tracking-tighter text-white mt-3">Sign in</h1>
      <p className="text-white/60 text-sm mt-2 mb-8">Welcome back, trader.</p>
      <form onSubmit={onSubmit} className="space-y-4" data-testid="login-form">
        <div>
          <label className="text-xs uppercase tracking-[0.2em] text-white/60">Email</label>
          <input
            data-testid="login-email"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full bg-black border border-white/15 focus:border-[#00F0FF] focus:outline-none text-white p-3 text-sm mt-2"
          />
        </div>
        <div>
          <label className="text-xs uppercase tracking-[0.2em] text-white/60">Password</label>
          <input
            data-testid="login-password"
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full bg-black border border-white/15 focus:border-[#00F0FF] focus:outline-none text-white p-3 text-sm mt-2"
          />
        </div>
        {error && <p data-testid="login-error" className="text-[#FF003C] text-sm">{error}</p>}
        <button data-testid="login-submit-btn" type="submit" disabled={loading} className="btn-primary w-full disabled:opacity-50">
          {loading ? "Signing in..." : "Sign In"}
        </button>
      </form>
      <GoogleLoginButton onError={setError} redirectTo="/" />
      <p className="text-white/50 text-sm mt-6 text-center">
        No account? <Link to="/register" className="text-[#00F0FF] hover:underline">Create one</Link>
      </p>
    </div>

  );
}
